<template>
  <v-card>
    <v-card-title class="dialog_header">{{ formTitle }}</v-card-title>
    <v-card-text>
      <formWrapper :validator="$v.form">
        <v-form @submit.prevent="handleSubmit">
          <v-row>
            <v-col cols="12" class="mt-5">
              <locale-select
                v-if="isEdit"
                v-model="locale"
                @change="changeLocale"
              />
            </v-col>
            <v-col cols="12" lg="6">
              <section class="file-upload">
                <form-group name="app_image" attribute="app_image">
                  <template slot-scope="{ attrs, listeners }">
                    <image-upload
                      dense
                      :label="$t('app_image')"
                      v-bind="attrs"
                      v-on="listeners"
                      :form="form"
                      fieldName="app_image"
                      :maxSize="maxSize"
                    />
                  </template>
                </form-group>
              </section>
            </v-col>
            <v-col cols="12" lg="6">
              <section class="file-upload">
                <form-group name="site_image" attribute="site_image">
                  <template slot-scope="{ attrs, listeners }">
                    <image-upload
                      dense
                      :label="$t('site_image')"
                      v-bind="attrs"
                      v-on="listeners"
                      :form="form"
                      fieldName="site_image"
                      :maxSize="maxSize"
                    />
                  </template>
                </form-group>
              </section>
            </v-col>
            <v-col cols="12" lg="6">
              <section class="file-upload">
                <form-group name="offer_image" attribute="offer_image">
                  <template slot-scope="{ attrs, listeners }">
                    <image-upload
                      dense
                      :label="$t('offer_image')"
                      v-bind="attrs"
                      v-on="listeners"
                      :form="form"
                      fieldName="offer_image"
                      :maxSize="maxSize"
                    />
                  </template>
                </form-group>
              </section>
            </v-col>
            <v-col cols="12" lg="6">
              <form-group name="link" attribute="fields.link">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    dense
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.link"
                  >
                  </v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" lg="6">
              <form-group name="name" attribute="fields.name">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    dense
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.name"
                  >
                  </v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="6">
              <form-group
                :validator="$v.form.app_priority"
                name="app_priority"
                attribute="fields.app_priority"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    type="number"
                    dense
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.app_priority"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group
                :validator="$v.form.site_priority"
                name="site_priority"
                attribute="fields.site_priority"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    type="number"
                    dense
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.site_priority"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6" class="mx-auto">
              <v-row>
                <v-col cols="12" md="6" class="mx-auto">
                  <v-switch
                    hide-details
                    :label="$t('table.offer')"
                    :true-value="1"
                    :false-value="0"
                    v-model="form.offer"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6" class="mx-auto">
                  <v-switch
                    hide-details
                    :label="$t('table.visible')"
                    :true-value="1"
                    :false-value="0"
                    v-model="form.visible"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-btn
                type="submit"
                :disabled="$v.form.$invalid"
                block
                class="primary"
                large
                rounded
                :loading="loading"
              >
                <v-icon>mdi-send</v-icon>
                {{ $t("button.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </formWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  minValue,
  url,
  requiredIf
} from "vuelidate/lib/validators";
import { ShowData, StoreData } from "@/helpers/apiMethods";
export default {
  name: "FormAction",
  data() {
    return {
      isEdit: false,
      loading: false,
      form: {
        name: "",
        link: "",
        app_image: "",
        site_image: "",
        offer_image: "",
        app_priority: "",
        site_priority: "",
        offer: 0,
        visible: 0
      },
      maxSize: 1.24,

      isPngImage: true,
      reset: false,
      locale: this.locale
    };
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("button.create");
      } else {
        return this.$t("button.edit");
      }
    }
  },
  methods: {
    onImageUpdate() {
      this.$emit("on-refresh-category");
    },
    handleShowData(locale = "en") {
      ShowData({
        reqName: "banners",
        param: this.$route.params.id,
        locale
      })
        .then(res => {
          const { banner } = res.data;
          this.form = {
            ...banner,
            visible: banner.visible ? 1 : 0,
            offer: banner.offer ? 1 : 0
          };
        })
        .catch(err => console.log(err));
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },
    onFileChange({ file }, name) {
      this.form[name] = file;
      this.reset = false;
    },
    onCreate() {
      StoreData({ reqName: `banners`, data: this.generateData() })
        .then(() => {
          this.$router.push("/banners");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate() {
      StoreData({
        reqName: `banners/${this.$route.params.id}`,
        data: this.generateData()
      })
        .then(() => {
          this.$router.push("/banners");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateData() {
      const formData = new FormData();
      const imgFiles = ["app_image", "offer_image", "site_image"];
      for (const key in this.form) {
        if (this.form[key] && this.form[key] !== "") {
          if (!imgFiles.includes(key)) {
            formData.append(key, this.form[key]);
          }
        }
      }
      imgFiles.forEach(imgField => {
        if (this.form[imgField] && !this.form[imgField]["id"]) {
          formData.append(imgField, this.form[imgField]);
        }
      });
      if (this.isEdit) {
        formData.append("_method", "put");
      }
      formData.append("locale", this.locale);
      return formData;
    },
    handleSubmit() {
      this.loading = true;
      if (!this.isEdit) {
        // in case create
        this.onCreate();
      } else {
        this.onUpdate();
      }
    },
    resetData() {
      this.$v.form.$reset();
      for (const formKey in this.form) {
        if (typeof this.form[formKey] == "string") {
          this.form[formKey] = "";
        } else {
          this.form[formKey] = 0;
        }
      }

      this.$v.form.$reset();
      this.reset = false;
      setTimeout(() => {
        this.reset = true;
      }, 50);
      this.$emit("update:loading", false);
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(150)
      },
      link: {
        required,
        url,
        minLength: minLength(12),
        maxLength: maxLength(190)
      },
      app_image: {
        required
      },
      site_image: {
        required
      },
      offer_image: {
        required: requiredIf(function() {
          if (this.form.offer) {
            return true;
          } else {
            return false;
          }
        })
      },
      app_priority: {
        minValue: minValue(1)
      },
      site_priority: {
        minValue: minValue(1)
      }
    }
  },
  watch: {
    $route: {
      handler({ params }) {
        if (params.id) {
          this.isEdit = true;
          this.handleShowData();
        } else {
          this.isEdit = false;
        }
      },
      immediate: true
    }
  }
};
</script>
